import { useState, useRef } from "react";
import HeroAbout from "@/components/common/HeroAbout";
import { history as historyData, HistoryCategory } from "@/constants";
import Container from "@/components/layout/Container";

const tabRanges = [
  { id: "tab1", label: "현재 ~ 2016" }, // 이미지와 동일하게 '현재' 문구 추가 가능
  { id: "tab2", label: "2015 ~ 2011" },
  { id: "tab3", label: "2010 ~ 2006" },
  { id: "tab4", label: "2005 ~ 1999" },
];

const AboutHistory = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const currentData: HistoryCategory | undefined = historyData.find(h => h.category === activeTab);
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    scrollRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Container>
      <HeroAbout />

      <div className="mx-auto w-full px-[2rem] wide:px-0">
        {/* 상단 연혁 탭 바  */}
        <nav
          className="sticky top-[60px] z-30 bg-white py-6 md:py-8 mb-[2rem]"
          aria-label="연혁 탭"
        >
          <ul className="grid grid-cols-2 gap-4 md:flex md:justify-center md:gap-4" role="tablist">
            {tabRanges.map(tab => (
              <li key={tab.id} className="w-full md:w-auto">
                <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`
            
            w-full md:min-w-[160px] px-4 py-3 md:py-3.5 rounded-full 
            text-[1.4rem] md:text-[1.7rem] transition-colors duration-200
            ${
              activeTab === tab.id
                ? "bg-[#4a4d50] text-white font-bold shadow-sm"
                : "bg-[#ebf0f2] text-[#4a4d50] font-normal hover:bg-gray-200"
            }
          `}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* 연혁 내용 (기존 유지) */}
        <div ref={scrollRef} className="relative space-y-0 scroll-mt-[170px]">
          {currentData?.years.map(yearData => (
            <div key={yearData.year} className="flex pb-[30px] flex-col lg:flex-row">
              <div className="w-full lg:w-[180px] flex-shrink-0">
                <span className="text-[2.8rem] font-bold text-black pb-[0.5rem] border-b-2 border-black inline-block lg:sticky lg:top-[160px] mb-3 lg:mb-0">
                  {yearData.year}
                </span>
              </div>

              <ul className="flex-grow">
                {yearData.list.map((item, idx) => (
                  <li
                    key={idx}
                    className="flex items-start text-[1.7rem] leading-[1.7] text-gray-7 py-[1rem] pl-5 border-b border-gray-2 relative before:content-[''] before:absolute before:left-0 before:top-[26px] before:w-1.5 before:h-1.5 before:bg-navy before:rounded-full"
                  >
                    <span className="font-semibold text-gray-8 w-[60px] flex-shrink-0">
                      {item.month}
                    </span>
                    <div className="flex-1">
                      {item.text.map((t, i) => (
                        <p key={i}>{t}</p>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default AboutHistory;
